import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const DoubleTick: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73475 9.17327L8.67608 10.1146L14.3197 4.47087L15.2626 5.41368L8.67608 12.0002L4.43341 7.75754L5.37622 6.81474L6.79275 8.23127L7.73475 9.17327ZM7.73588 7.28814L11.0376 3.98633L11.9778 4.92652L8.67608 8.22827L7.73588 7.28814ZM5.8514 11.0582L4.90939 12.0002L0.666748 7.75754L1.60955 6.81474L2.55157 7.7568L2.55077 7.75754L5.8514 11.0582Z"
        fill={color}
      />
    </svg>
  );
};

export default DoubleTick;
